export enum StarPrinterScannerEventAction {
  stateChanged = 'stateChanged',
  dataReceived = 'dataReceived'
}
